define('customPlugins/atnBooleanToggle',[
        'knockout', 'lodash', 'jquery'
    ],
    function(ko, _, $) {
        'use strict';
        
        // checbox property change on 0 and 1 instead on false and true
        ko.bindingHandlers.atnBooleanToggle = {
            init: function(element, valueAccessor) {
                var value = valueAccessor();
                // binding click to change the value
                ko.applyBindingsToNode(element, {
                    click: function(data,event) {
                        value(!value());
                        event.stopPropagation();
                    }
                });
            }
        };
    });
